import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { IModelEntity } from '@pit/core';
import { IEntityDataService, EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFactory } from './entity.store.factory';

export class EntityStoreEffects<T extends IModelEntity> {

    constructor(protected dataAccessName: string, protected actions$: Actions, protected entityStoreFactory: EntityStoreFactory<T>, protected dataServiceAccessor: EntityDataServiceAccessorService) {
    }

    deleteItem$: Observable<Action> = this.entityStoreFactory.getEffect('delete.single')(this.actions$, this.dataServiceAccessor);

    loadAll$: Observable<Action> = this.entityStoreFactory.getEffect('load.all')(this.actions$, this.dataServiceAccessor);

    loadAllPaging$: Observable<Action> = this.entityStoreFactory.getEffect('load.all.paging')(this.actions$, this.dataServiceAccessor);

    load$: Observable<Action> = this.entityStoreFactory.getEffect('load.single')(this.actions$, this.dataServiceAccessor);

    save$: Observable<Action> = this.entityStoreFactory.getEffect('save.single')(this.actions$, this.dataServiceAccessor);

    protected get entityDataService(): IEntityDataService<T> {
        return this.dataServiceAccessor.getEntityDataService(this.dataAccessName);
    }

}
